import React, { useState } from "react";
import { useSelector } from "react-redux";
import Transactions from "./Transactions";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";

const CampaignDetails = ({ campaign }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { rewardTypeMapping } = useSelector((state) => state.reward);

  const toggle = () => setIsOpenModal(!isOpenModal);

  return (
    <>
      <div className="btn btn-primary btn-sm" onClick={toggle}>
        View
      </div>

      <Offcanvas
        isOpen={isOpenModal}
        toggle={toggle}
        direction="end"
        style={{ width: "90vw" }}
      >
        <OffcanvasHeader toggle={toggle} className="border-bottom pb-3">
          {campaign?.launcherName}
        </OffcanvasHeader>
        <OffcanvasBody>
          <Transactions launcherId={campaign?.launcherId} />
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default CampaignDetails;
